import { DEFAULT_LOCALE } from "ra-core"

const COUNTRY_TO_LOCALE = {
  BE: 'nl',
  BR: 'pt',
  DE: 'de',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  MX: 'es_MX',
  NL: 'nl',
  PL: 'pl',
  PT: 'pt',
  SE: 'sv',
  US: 'en_US',
  CR: 'es',
  CO: 'es',
  MG: 'fr',
  TH: 'th',
  DK: 'da',
  FI: 'fi',
  NO: 'no',
}

export const getPrimaryLocaleForCountry = (iso2: string): string => {
  const locale = COUNTRY_TO_LOCALE[iso2.toUpperCase() as keyof typeof COUNTRY_TO_LOCALE]
  return locale || DEFAULT_LOCALE
}